import { DownloadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Row, Select, Tabs } from 'antd';
import Column from "antd/es/table/Column";
import { Table } from 'antd/lib';
import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    DoughnutController,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from 'chart.js';
import { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import { dateCommon } from '../../helpers/common';
import { NhanVienTheoThamNienCongTacResponse } from '../../models/nhanvien/NhanVien';
import { LayDSNhanVienTheoThamNienCongTac, XuatExcelDieuDongLuanChuyen, XuatExcelNhanVienNghiViec, XuatExcelNhanVienTheoThamNienCongTac, thongKeNhanVien } from '../../services/nhanvien';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import LoiViPhamNhanVien from './thongke/LoiViPhamNhanVien';
import XepLoaiNhanVien from './thongke/XepLoaiNhanVien';
import ThongKeNhanSuPhongBan from './ThongKeNhanSuPhongBanTrangChu';
import ThongKeNhanSuChucDanhTrangChu from './ThongKeNhanSuChucDanhTrangChu';
import ThongKeNhanSuDangDoanPhongBan from './ThongKeNhanSuDangDoanPhongBan';
ChartJS.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    DoughnutController,
    BarElement,
    Title,
    Tooltip,
    Legend
);
var optionsThamNienCongTac = [{
    value: 1,
    label: "Thâm niên: Dưới 1 năm"
},
{
    value: 2,
    label: "Thâm niên: Từ 1 đến dưới 3 năm"
},
{
    value: 3,
    label: "Thâm niên: Từ 3 đến dưới 5 năm"
},
{
    value: 4,
    label: "Thâm niên: Từ 5 đến dưới 10 năm"
},
{
    value: 5,
    label: "Thâm niên: Trên 10 năm"
},
]

const ThongKeNhanSu = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [formNghiViec] = Form.useForm();
    const [formDieuDong] = Form.useForm();
    const [dataTable, setDataTable] = useState<NhanVienTheoThamNienCongTacResponse[]>([]);
    const [value, setValue] = useState<number>(0);
    const [dataGioiTinh, setDataGioiTinh] = useState({       
        datasets: [
            {
                label: 'Giới tính',
                data: [0,0],
                backgroundColor: [
                    'rgb(255, 99, 132)',
                    'rgb(54, 162, 235)',              
                ],
            },
        ],
        labels: ['Nữ', 'Nam'],
    });
    const [dataTrinhDoHV, setDataTrinhDoHV] = useState({
        datasets: [
            {
                label: 'Trinh Do Hoc Van',
                data: [0, 0, 0, 0],
                backgroundColor: [
                    'rgb(255, 99, 132)',
                    'rgb(54, 162, 235)',
                    'rgb(255, 206, 86)',
                    'rgb(75, 192, 192)',
                ],
                categoryPercentage: 0.3
            },
        ],
        labels: ['Đại học', 'Thạc sĩ', 'Tiến sĩ', 'Cử Nhân'],
    });

    // Legend tùy chỉnh
    const [legendGioiTinh, setLegendGioiTinh] = useState<{ label: string; color: string; value: number }[]>([]);
    const [legendTrinhDo, setLegendTrinhDo] = useState<{ label: string; color: string; value: number }[]>([]);

    const loadDSNhanVien = async () => {
        try {
            setIsLoading(true);
            const data = await LayDSNhanVienTheoThamNienCongTac(value);

            const dataKeys = data.map((item, index) => ({ ...item, key: index }));
            setDataTable(dataKeys);
            setIsLoading(false);
        }
        catch (err: any) {
            setIsLoading(false);
            toast.error('Danh sách nhân viên đã xảy ra lỗi, vui lòng thử lại!');
        }
    }

    const handleThamNienFilterChange = async (value: number | null) => {
        try {
            setIsLoading(true);
            if (value !== null) {
                setValue(value);
                const data = await LayDSNhanVienTheoThamNienCongTac(value);
                const dataKeys = data.map((item, index) => ({ ...item, key: index }));
                setDataTable(dataKeys);
            }
            else {
                setValue(0);
            }
            setIsLoading(false);
        } catch (err: any) {
            setIsLoading(false);
            toast.error('Danh sách nhân viên đã xảy ra lỗi, vui lòng thử lại!');
        }
    };

    const thongKeData = async () => {
        try {
            const data = await thongKeNhanVien();

            const tongNhanVienNam = data.tongNhanVienNam;
            const tongNhanVienNu = data.tongNhanVienNu;
            const colorsGioiTinh = ['rgb(255, 99, 132)', 'rgb(54, 162, 235)'];
            const labelsGioiTinh = ['Nữ', 'Nam'];
            const dataGioiTinhValues = [tongNhanVienNu, tongNhanVienNam];
            setDataGioiTinh({
                datasets: [{
                    label: 'Giới tính',
                    data: dataGioiTinhValues,
                    backgroundColor: colorsGioiTinh,
                }],
                labels: labelsGioiTinh,
            });
            setLegendGioiTinh(labelsGioiTinh.map((lbl, i) => ({
                label: lbl,
                color: colorsGioiTinh[i],
                value: dataGioiTinhValues[i]
            })));

            const colorsTrinhDo = [
                'rgb(255, 99, 132)',
                'rgb(54, 162, 235)',
                'rgb(255, 206, 86)',
                'rgb(75, 192, 192)',
            ];
            const labelsTrinhDo = data.thongKeTrinhDoResponse.map((item) => item?.ten);
            const dataTrinhDoValues = data.thongKeTrinhDoResponse.map((item) => item.soLuongNhanVien);
            setDataTrinhDoHV({
                labels: labelsTrinhDo,
                datasets: [
                    {
                        label: 'Số lượng',
                        data: dataTrinhDoValues,
                        backgroundColor: colorsTrinhDo,
                        categoryPercentage: 0.15
                    },
                ],
            });
            setLegendTrinhDo(labelsTrinhDo.map((lbl, i) => ({
                label: lbl,
                color: colorsTrinhDo[i % colorsTrinhDo.length],
                value: dataTrinhDoValues[i]
            })));

        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, vui lòng thử lại!');
        }
    }

    // Function to create doughnut chart
    const createChart = () => {
        const ctx = document.getElementById('doughnutChart') as HTMLCanvasElement;
        if (ctx) {
            ChartJS.getChart(ctx)?.destroy(); 
            new ChartJS(ctx, {
                type: 'doughnut',
                data: dataGioiTinh,
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    var label = context.label || '';
                                    var value = context.formattedValue;
                                    var percentage = context.dataset.data[context.dataIndex] / context.dataset.data.reduce((a, b) => a + b, 0) * 100;
                                    return label + ': ' + value + ' (' + percentage.toFixed(2) + '%)';
                                }
                            }
                        }
                    },
                    layout: {
                        padding: {
                            left: 50,
                            right: 50,
                            top: 30,
                            bottom: 15
                        }
                    }
                }
            });
        }
    };

    // Function to create bar chart
    const createBarChart = () => {
        const ctx = document.getElementById('barChart') as HTMLCanvasElement;
        if (ctx) {
            const chart = ChartJS.getChart(ctx);
            if (chart) {
                chart.destroy();
            }
            new ChartJS(ctx, {
                type: 'bar',
                data: dataTrinhDoHV,
                options: {
                    maintainAspectRatio: false,  
                    responsive: true,
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context: any) {
                                    let label = context.dataset.label || '';

                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.parsed.y !== null) {
                                        label += context.parsed.y.toLocaleString();
                                        const dataset = context.chart.data.datasets[context.datasetIndex];
                                        const total = dataset.data.reduce((prev: any, curr: any) => prev + curr, 0);
                                        const percentage = ((context.parsed.y / total) * 100).toFixed(2);
                                        label += ' (' + percentage + '%)';
                                    }
                                    return label;
                                }
                            }
                        }
                    },
                }
            });
        }
    };

    useEffect(() => {
        createChart();
    }, [dataGioiTinh]);

    useEffect(() => {
        createBarChart();
    }, [dataTrinhDoHV]);

    useEffect(() => {
        loadDSNhanVien();
        thongKeData();
    }, []);

    const disabledEndDate = (current: Dayjs | null): boolean => {
        const startDate = formNghiViec.getFieldValue('tuNgay');
        return !!startDate && current ? current.isBefore(startDate, 'day') : false;
    };

    const disabledStartDate = (current: Dayjs | null): boolean => {
        const endDate = formNghiViec.getFieldValue('denNgay');
        return !!endDate && current ? current.isAfter(endDate, 'day') : false;
    };

    const disabledEndDate2 = (current: Dayjs | null) => {
        const startDate = formDieuDong.getFieldValue('tuNgayDD');
        return !!startDate && current ? current.isBefore(startDate, 'day') : false;
    };

    const disabledStartDate2 = (current: Dayjs | null): boolean => {
        const endDate = formDieuDong.getFieldValue('denNgayDD');
        return !!endDate && current ? current.isAfter(endDate, 'day') : false;
    };

    const handleExportNghiViec = async () => {
        dispatch(showLoadingScreen());
        try {
            const values = await formNghiViec.validateFields();
            const { tuNgay, denNgay } = values;
            var response = await XuatExcelNhanVienNghiViec(tuNgay, denNgay);
            let link = document.createElement('a');
            link.download = `DSNhanVienNghiViec.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex) {
            toast.error("Xuất báo cáo không thành công. Vui lòng thử lại");
        }

        dispatch(hideLoadingScreen());
    }

    const handleExportDieuDong = async () => {
        dispatch(showLoadingScreen());
        try {
            const values = await formDieuDong.validateFields();
            const { tuNgayDD, denNgayDD } = values;

            var response = await XuatExcelDieuDongLuanChuyen(tuNgayDD, denNgayDD);
            let link = document.createElement('a');
            link.download = `BCDieuDongLuanChuyen.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex: any) {
            if (!ex.errorFields || !ex.errorFields.length) {
                toast.error("Xuất báo cáo không thành công. Vui lòng thử lại");
            }
        }

        dispatch(hideLoadingScreen());
    }

    const handleExportNhanVienTheoThamNienCongTac = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await XuatExcelNhanVienTheoThamNienCongTac(value);
            let link = document.createElement('a');
            link.download = `BCNhanVienTheoThamNienCongTac.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex: any) {
            if (!ex.errorFields || !ex.errorFields.length) {
                toast.error("Xuất báo cáo không thành công. Vui lòng thử lại");
            }
        }

        dispatch(hideLoadingScreen());
    }

    return (
        <section>
            <ContentHeader title="Báo cáo thống kê theo nhân sự" />
            <Row>
                <Col span={24}>
                    <Tabs defaultActiveKey="1" items={[
                        {
                            key: '1',
                            label: 'Báo cáo nhân sự',
                            children:
                                <Row>
                                    <Col span={24} className="card card-body">
                                        <Form form={formNghiViec}>
                                            <Row gutter={10}>
                                                <Col span={4}>
                                                    <label>Nghỉ việc:</label>
                                                </Col>
                                                <Col span={5}>
                                                    <Form.Item
                                                        name="tuNgay"
                                                    >
                                                        <DatePicker
                                                        disabledDate={disabledStartDate}
                                                            changeOnBlur={true}
                                                            style={{ width: "100%" }}
                                                            placeholder="--Từ ngày--"
                                                            format={["DD/MM/YYYY", "DDMMYYYY"]}
                                                            showToday={false}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={5} >
                                                    <Form.Item
                                                        name="denNgay"
                                                    >
                                                        <DatePicker
                                                           changeOnBlur={true}
                                                            style={{ width: "100%" }}
                                                            placeholder="--Đến ngày--"
                                                            format={["DD/MM/YYYY", "DDMMYYYY"]}
                                                            disabledDate={disabledEndDate}
                                                            showToday={false}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col>
                                                    <Button
                                                        className="hrm-btn hrm-btn-success"
                                                        icon={<DownloadOutlined rev="" />}
                                                        onClick={handleExportNghiViec}
                                                    >Xuất excel
                                                    </Button>
                                                </Col>  
                                            </Row>
                                        </Form>
                                        <Form form={formDieuDong}>
                                            <Row gutter={10}>
                                                <Col span={4}>
                                                    <label>Điều động luân chuyển:</label>
                                                </Col>
                                                <Col span={5}>
                                                    <Form.Item
                                                        name="tuNgayDD"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Chọn ngày bắt đầu',
                                                            },
                                                        ]}
                                                    >
                                                        <DatePicker
                                                            changeOnBlur={true}
                                                            style={{ width: "100%" }}
                                                            placeholder="--Từ ngày--"
                                                            format={["DD/MM/YYYY", "DDMMYYYY"]}
                                                            disabledDate={disabledStartDate2}
                                                            showToday={false}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={5}>
                                                    <Form.Item
                                                        name="denNgayDD"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Chọn ngày kết thúc',
                                                            },
                                                        ]}
                                                    >
                                                        <DatePicker
                                                            changeOnBlur={true}
                                                            style={{ width: "100%" }}
                                                            placeholder="--Đến ngày--"
                                                            format={["DD/MM/YYYY", "DDMMYYYY"]}
                                                            disabledDate={disabledEndDate2}
                                                            showToday={false}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col>
                                                    <Button
                                                        className="hrm-btn hrm-btn-success"
                                                        icon={<DownloadOutlined rev="" />}
                                                        onClick={handleExportDieuDong}
                                                    >Xuất excel
                                                    </Button>
                                                </Col>                                             
                                            </Row>
                                        </Form>
                                        <LoiViPhamNhanVien />
                                        <XepLoaiNhanVien />
                                    </Col>
                                </Row>
                        }
                    ]}>
                    </Tabs>
                </Col>
            </Row>
            <Row>
                <Col span={8} className="px-2">
                    <Tabs defaultActiveKey="1" items={[
                        {
                            key: '1',
                            label: 'Biểu đồ thống kê theo giới tính',
                            children:
                                <Row>
                                    <Col className="card card-body" style={{ padding: 16 }}>
                                        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                                            <div style={{ flex: '0 0 70%', height: 240 }}>
                                                <canvas id="doughnutChart"></canvas>
                                            </div>
                                            {legendGioiTinh.length > 0 && (() => {
                                                const tongGT = legendGioiTinh.reduce((s, d) => s + d.value, 0);
                                                return (
                                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
                                                        {legendGioiTinh.map((d) => {
                                                            const pct = tongGT > 0 ? ((d.value / tongGT) * 100).toFixed(1) : '0.0';
                                                            return (
                                                                <div key={d.label} style={{ display: 'flex', alignItems: 'center', gap: 7, background: '#f5f7fb', borderRadius: 6, padding: '6px 10px', fontSize: 13 }}>
                                                                    <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', background: d.color, flexShrink: 0 }} />
                                                                    <span style={{ color: '#444', flex: 1 }}>{d.label}</span>
                                                                    <span style={{ fontWeight: 700, color: '#071C50' }}>{d.value}</span>
                                                                    <span style={{ color: '#888', fontSize: 11 }}>({pct}%)</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    </Col>
                                </Row>
                        },
                    ]}>
                    </Tabs>
                </Col>
                <Col span={16} className="px-2">
                    <Tabs defaultActiveKey="1" items={[
                        {
                            key: '1',
                            label: 'Biểu đồ thống kê theo trình độ học vấn',
                            children:
                                <Row>
                                    <Col className="card card-body" style={{ padding: 16 }}>
                                        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                                            <div style={{ flex: '0 0 75%', height: 240 }}>
                                                <canvas id="barChart"></canvas>
                                            </div>
                                            {legendTrinhDo.length > 0 && (() => {
                                                const tongTD = legendTrinhDo.reduce((s, d) => s + d.value, 0);
                                                return (
                                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
                                                        {legendTrinhDo.map((d) => {
                                                            const pct = tongTD > 0 ? ((d.value / tongTD) * 100).toFixed(1) : '0.0';
                                                            return (
                                                                <div key={d.label} style={{ display: 'flex', alignItems: 'center', gap: 7, background: '#f5f7fb', borderRadius: 6, padding: '6px 10px', fontSize: 13, minWidth: 0 }}>
                                                                    <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', background: d.color, flexShrink: 0 }} />
                                                                    <span style={{ color: '#444', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={d.label}>{d.label}</span>
                                                                    <span style={{ fontWeight: 700, color: '#071C50', flexShrink: 0 }}>{d.value}</span>
                                                                    <span style={{ color: '#888', fontSize: 11, flexShrink: 0 }}>({pct}%)</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    </Col>
                                </Row>
                        },
                    ]}>
                    </Tabs>
                </Col>
            </Row>
            <Row>
                <ThongKeNhanSuPhongBan />
            </Row>
            <Row>
                <ThongKeNhanSuDangDoanPhongBan />
            </Row>
            <Row>
                <ThongKeNhanSuChucDanhTrangChu />
            </Row>
            <Row>
                <Col span={24}>
                    <Tabs defaultActiveKey="1" items={[
                        {
                            key: '1',
                            label: 'Báo cáo thâm niên công tác',
                            children:
                                <>
                                    <Row gutter={13}>
                                        <Col span={9}>
                                            <Form>
                                                <Form.Item
                                                    name="loaiThamNien"
                                                    label="Thâm niên công tác"
                                                    style={{ width: '100%' }}
                                                >
                                                    <Select
                                                        notFoundContent="Không có dữ liệu"
                                                        onChange={(value) => handleThamNienFilterChange(value)}
                                                        options={optionsThamNienCongTac}
                                                        placeholder="Chọn thâm niên công tác"
                                                        allowClear={true}
                                                    />
                                                </Form.Item>
                                            </Form>
                                        </Col>
                                        <Col span={3}>
                                            <Button
                                                className="hrm-btn hrm-btn-success"
                                                icon={<DownloadOutlined rev="" />}
                                                onClick={handleExportNhanVienTheoThamNienCongTac}
                                            >Xuất excel
                                            </Button>
                                        </Col>
                                    </Row>

                                    <Row style={{ marginTop: '-17px'}}>
                                        <Table
                                            dataSource={dataTable}
                                            locale={{ emptyText: "Không có dữ liệu" }}
                                            loading={isLoading}
                                            pagination={false}
                                            scroll={{ x: true }}
                                            sticky
                                        >
                                            <Column
                                                title="STT"
                                                key="stt"
                                                align="center"
                                                width={70}
                                                render={(text, record: NhanVienTheoThamNienCongTacResponse, index) => {
                                                    if (record.isTieuDe) {
                                                        return <b>{record.stt}</b>;
                                                    } else {
                                                        return record.stt;
                                                    }
                                                }} />
                                            <Column
                                                title="Họ và tên nhân viên"
                                                dataIndex={['hoTen']}
                                                key="hoTen"
                                                width={250}
                                                render={(hoTen, record: NhanVienTheoThamNienCongTacResponse, index) => {
                                                    if (record.isTieuDe) {
                                                        return <b>{record.hoTen}</b>;
                                                    } else {
                                                        return hoTen;
                                                    }
                                                }}
                                            />
                                            {/* <Column title="Chức vụ" dataIndex={['tenChucVu']} key="tenChucVu" width={170} />
                                            <Column title="Phòng ban" dataIndex={['tenDonVi']} key="tenDonVi" width={200} /> */}
                                            <Column
                                                title="Ngày sinh"
                                                dataIndex={['ngaySinh']}
                                                key="ngaySinh"
                                                width={100}
                                                align="center"
                                                render={(ngaySinh) => dateCommon.formatDate(ngaySinh)} />
                                            <Column
                                                title="Thời gian bắt đầu đi làm"
                                                dataIndex={['thoiGianBatDauDiLam']}
                                                key="thoiGianBatDauDiLam"
                                                align="center"
                                                width={150}
                                                render={(thoiGianBatDauDiLam) => dateCommon.formatDate(thoiGianBatDauDiLam)}
                                            />
                                            <Column
                                                title="Thời gian vào làm việc tại Quỹ (cũ)"
                                                dataIndex={['ngayVaoLam']}
                                                key="ngayVaoLam"
                                                align="center"
                                                width={160}
                                                render={(ngayVaoLam) => dateCommon.formatDate(ngayVaoLam, 'MM/yyyy')} />
                                            <Column
                                                title="Thâm niên công tác tại Quỹ (cũ)"
                                                key="soNamThamNienQuy"
                                                align="center"
                                                width={200}
                                                render={(text, record: NhanVienTheoThamNienCongTacResponse) => {
                                                    if (record.soNamThamNienQuy !== null && record.soThangThamNienQuy !== null) {
                                                        return `${record.soNamThamNienQuy} năm ${record.soThangThamNienQuy} tháng`;
                                                    } else {
                                                        return '';
                                                    }
                                                }}
                                            />
                                            <Column
                                                title="Thời gian bắt đầu làm việc tại Quỹ (mới)"
                                                dataIndex={['thoiGianVaoLamTaiPhongBan']}
                                                key="thoiGianVaoLamTaiPhongBan"
                                                align="center"
                                                width={170}
                                                render={(thoiGianVaoLamTaiPhongBan) => dateCommon.formatDate(thoiGianVaoLamTaiPhongBan)}
                                            />
                                            <Column
                                                title="Số năm công tác tại Quỹ (mới)"
                                                key="soNamCongTacTaiPhongban"
                                                align="center"
                                                width={200}
                                                render={(text, record: NhanVienTheoThamNienCongTacResponse) => {
                                                    if (record.soNamPhongban !== null && record.soThangPhongBan !== null) {
                                                        return `${record.soNamPhongban} năm ${record.soThangPhongBan} tháng`;
                                                    } else {
                                                        return '';
                                                    }
                                                }}
                                            />
                                            <Column
                                                title="Tổng số năm đi làm"
                                                key="soNamDiLam"
                                                align="center"
                                                width={200}
                                                render={(text, record: NhanVienTheoThamNienCongTacResponse) => {
                                                    if (record.soNamDiLam !== null && record.soThangDiLam !== null) {
                                                        return `${record.soNamDiLam} năm ${record.soThangDiLam} tháng`;
                                                    } else {
                                                        return '';
                                                    }
                                                }}
                                            />
                                        </Table>
                                    </Row>
                                </>
                        },
                    ]}>
                    </Tabs>
                </Col>
            </Row>
        </section>
    );
};

export default ThongKeNhanSu;
